"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var UserList = /*#__PURE__*/function () {
  function UserList(client) {
    (0, _classCallCheck2["default"])(this, UserList);
    this.client = client;
    this.resourceUrl = '/user';
  }

  (0, _createClass2["default"])(UserList, [{
    key: "getUserList",
    value: function getUserList(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/list"), data, args);
    }
  }, {
    key: "updateUserPlan",
    value: function updateUserPlan(data, userId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/update-plan-code"), data, args);
    }
  }, {
    key: "updateUserCompany",
    value: function updateUserCompany(data, userId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/update-company"), data, args);
    }
  }, {
    key: "updateUserAffiliation",
    value: function updateUserAffiliation(data, userId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/update-ecosystem"), data, args);
    }
  }, {
    key: "toggleAdminPrivileges",
    value: function toggleAdminPrivileges(data, userId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/toggle-admin-privileges"), data, args);
    }
  }, {
    key: "toggleTeamPrivileges",
    value: function toggleTeamPrivileges(data, userId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/toggle-company-admin-privileges"), data, args);
    }
  }, {
    key: "toggleEcosystemPrivileges",
    value: function toggleEcosystemPrivileges(data, userId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/toggle-ecosystem-admin-privileges"), data, args);
    }
  }, {
    key: "toggleCoachPrivileges",
    value: function toggleCoachPrivileges(data, userId) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(userId, "/toggle-coach-privileges"), data, args);
    }
  }, {
    key: "getCoaches",
    value: function getCoaches() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      return this.client.get("".concat(this.resourceUrl, "/coaches"), args);
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(data, id) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(id, "/update-password"), data, args);
    }
  }, {
    key: "getPromocodeData",
    value: function getPromocodeData() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      return this.client.get("/admin/promo-code", args);
    }
  }, {
    key: "exportUserCSV",
    value: function exportUserCSV(data) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.post("/admin/export-user-csv", data, args);
    }
  }, {
    key: "getCoachClientsAndGroups",
    value: function getCoachClientsAndGroups(coachId) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        args[_key13 - 1] = arguments[_key13];
      }

      return this.client.get("/admin/coach/".concat(coachId, "/clients-and-groups"), args);
    }
  }, {
    key: "updateUserJourney",
    value: function updateUserJourney(clientId, data) {
      var _this$client;

      for (var _len14 = arguments.length, args = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        args[_key14 - 2] = arguments[_key14];
      }

      return (_this$client = this.client).put.apply(_this$client, ["/journey?clientId=".concat(clientId), data].concat(args));
    }
  }, {
    key: "getJouneySearchMedia",
    value: function getJouneySearchMedia(search) {
      var includeExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.get("/medias/search/?search=".concat(encodeURIComponent(search), "&includeExtra=").concat(includeExtra), args);
    }
  }, {
    key: "deleteUserAccount",
    value: function deleteUserAccount(userId) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        args[_key16 - 1] = arguments[_key16];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(userId), args);
    }
  }, {
    key: "allUserData",
    value: function allUserData(userId) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("/admin/merge-users/".concat(userId), args);
    }
  }, {
    key: "mergeUser",
    value: function mergeUser(data) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        args[_key18 - 1] = arguments[_key18];
      }

      return this.client.post("/admin/merge-users", data, args);
    }
  }]);
  return UserList;
}();

exports["default"] = UserList;